import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL ?? 'http://127.0.0.1:8000/api/';

const API = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const getCategoriesListAPI = async (token) => {
    try {
        const response = await API.get('admin/categories', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response.status === 401) {
            return {
                "status": false,
                "message": 'Something went wrong please try again.'
            }
        }
    }
};

// Create a new category
export const createCategoryAPI = async (formData, token) => {    
    try {
        const response = await API.post('admin/categories/store', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data', // Required for file uploads
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error; // Re-throw error for further handling
    }
};

// Create a new category
export const getCategoryAPI = async (id, token) => {   
    try {
        const response = await API.get(`admin/categories/show/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data', // Required for file uploads
            },
        });
        return response.data.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error; // Re-throw error for further handling
    }
};

export const updateCategoryAPI = async (formData, id, token) => {    
    try {
        const response = await API.post(`admin/categories/update/${id}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const deleteCategoryAPI = async (id, token) => {    
    try {
        const response = await API.get(`admin/categories/delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};